import { motion } from 'framer-motion';
import './ScrollIndicator.css';

const ScrollIndicator = (): JSX.Element => {
  return (
    <motion.div 
      className="scroll-indicator"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, delay: 1 }}
    >
      <span className="scroll-text">scroll</span>
      <div className="scroll-line">
        <motion.div 
          className="scroll-dot"
          initial={{ top: -4 }}
          animate={{ 
            top: ["calc(0% - 4px)", "calc(100% - 4px)"],
            opacity: [1, 1, 0],
          }}
          transition={{ 
            duration: 3,
            repeat: Infinity,
            ease: [0.4, 0.0, 0.2, 1],
            repeatDelay: 1.5,
            times: [0, 0.8, 1]
          }}
        />
      </div>
    </motion.div>
  );
};

export default ScrollIndicator; 